export type Environment = 'production' | 'develop' | 'staging' | 'local';

export function getEnvironment(): Environment {
  let environment: Environment = 'production';

  if (window.location.host === 'develop.cutwise.com') {
    environment = 'develop';
  } else if (window.location.host === 'staging.cutwise.com') {
    environment = 'staging';
  } else if (window.location.host.includes('cutwise.local')) {
    environment = 'local';
  }

  return environment;
}
